import {
    getSessionToken
} from "../helpers/getSessionToken";
import {
    detailsGrid,
    detailsSection,
    initDetailsTrigger,
} from "./detailsModal";

const SESSION_DETAILS_MODAL_ID = 'growtypeChatSessionDetailsModal';

const sessionDetailsConfig = {
    modalId: SESSION_DETAILS_MODAL_ID,
    title: 'Session details',
    bodyClass: 'growtype-chat-session-details-body',
    copyClass: 'growtype-chat-session-details-copy',
    copyLabel: 'session details',
    isEnabled: () => !!window.growtype_chat_ajax?.show_session_details,
    getAction: () => window.growtype_chat_ajax?.session_details_action,
    getSessionToken: ($trigger) => {
        const $chatForm = $trigger.closest('.g-chatform').length
            ? $trigger.closest('.g-chatform')
            : jQuery('.g-chatform').first();
        return getSessionToken($chatForm);
    },
    buildRequest: () => ({}),
    renderError: () => 'Unable to load session details.',
    onAbort: () => console.error('[session-details] missing session token'),
    render(data) {
        const currentUser = data.current_user || {};

        const sections = [
            detailsGrid('Session Overview', [
                ['Session ID', data.session_id],
                ['Session Name', data.session_name],
                ['Session Token', data.session_token],
                ['Bot Slug', data.bot_slug],
                ['Messages Count', data.messages_count],
                ['Pinned Messages Count', data.pinned_messages_count],
                ['Created At', data.created_at],
                ['Updated At', data.updated_at],
            ]),
            detailsGrid('Current User Context', [
                ['User ID', currentUser.id],
                ['Is Logged In', currentUser.is_logged_in],
                ['User Token', currentUser.user_token],
            ]),
            detailsSection('Session Users', data.session_users),
            detailsSection('Session Settings', data.session_settings),
        ];

        return `
            <div class="growtype-chat-session-details" style="display:flex;flex-direction:column;gap:18px;">
                ${sections.join('')}
            </div>
        `;
    },
};

export function initSessionDetails() {
    initDetailsTrigger({
        selector: '.g-chat-btn-session-details',
        event: 'click.growtypeChatSessionDetails',
        config: sessionDetailsConfig,
    });
}
